






























import { computed, defineComponent, onUnmounted, ref } from '@vue/composition-api';
import soilApiService from '@/services/soilApiService';
import { isNotEmpty, isValidEmailAddress } from '@/utils/rules';

export default defineComponent({
	components: {},
	props: {
		groupId: { type: String, required: true },
	},
	setup(props, { root }) {
		const isFormValid = ref<boolean>(false);
		const email = ref<string>('');
		const createError = ref();
		const isLoading = ref(false);
		const error = computed<string>(() =>
			createError.value ? 'An error occurred while attempting to create the membership.' : ''
		);

		const handleSubmit = async () => {
			if (!isFormValid.value) {
				return;
			}

			try {
				isLoading.value = true;
				await soilApiService.createMembership({ groupId: props.groupId, userEmail: email.value });
				root.$router.push(`/groups/${props.groupId}`);
			} catch (err) {
				createError.value = err;
			} finally {
				isLoading.value = false;
			}
		};

		const handleCancel = async () => {
			root.$router.push(`/groups/${props.groupId ? props.groupId : ''}`);
		};

		onUnmounted(() => {
			root.$store.dispatch('memberships/getMemberships', props.groupId);
		});

		return {
			isFormValid,
			email,
			isLoading,
			error,
			handleSubmit,
			handleCancel,
			isValidEmailAddress,
			isNotEmpty,
		};
	},
});
